import { RequiredStartupProviders } from 'app/agriculture/contexts/RequiredStartupProviders/RequiredStartupProviders';
import { MapProviders } from 'app/agriculture/contexts/MapProviders';
import { IndependentProviders } from 'app/agriculture/contexts/IndependentProviders';
import { TimelineContextProvider } from 'app/agriculture/AgTimeline/context/TimelineContext';
import { ReactNode } from 'react';
import { MUIOverride } from 'app/agriculture/material';

export const GlobalContextProvider = ({ children }: { children: ReactNode }) => {
    return (
        <RequiredStartupProviders>
            <MapProviders>
                <TimelineContextProvider>
                    <IndependentProviders>
                        <MUIOverride>{children}</MUIOverride>
                    </IndependentProviders>
                </TimelineContextProvider>
            </MapProviders>
        </RequiredStartupProviders>
    );
};
